<template>
  <div class="row">
    <div v-if="order.items.length > 0" class="col-sm-12 mb-4 d-none d-sm-block">
      <div class="row">
        <div class="col-sm-2"><h5>Artículo</h5></div>
        <div class="col-sm-1"><h5>Cantidad</h5></div>
        <div class="col-sm-1"><h5>Precio Unitario (USD)</h5></div>
        <div class="col-sm-1"><h5>Costo dist. (USD)</h5></div>
        <div class="col-sm-1"><h5>Tasa cambio</h5></div>
        <div class="col-sm-6">
          <div class="row">
            <div class="offset-2 col-sm-3">
              <h5>% Comision</h5>
            </div>
            <div class="col-sm-3">
              <h5>Monto Comision USD</h5>
            </div>
            <div class="col-sm-3">
              <h5>Monto Comision ARS</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(item, index) in order.items" :key="index" class="col-sm-12 d-none d-sm-block">
      <div class="row align-items-center">
        <div class="col-sm-2 font-italic">
          {{ item.article.description }}
        </div>
        <div class="col-sm-1">
          <span>{{ item.quantity }}</span>
        </div>
        <div class="col-sm-1">
          <span>{{ item.price }}</span>
        </div>
        <div class="col-sm-1">
          <span>{{ item.distributorCost }}</span>
        </div>
        <div class="col-sm-1">
          <span>{{ validDollarQuotation(dollarQuotation) | toCurrencyARS }}</span>
        </div>

        <div class="col-sm-6">
          <div class="row">
            <div v-if="isAdmin || isDistributor" class="col-sm-2 text-right pr-4">
              <small>Distribuidor</small>
            </div>
            <div class="col-sm-3">
              <small>{{ getDistributorCommission(item) | percentage }}</small>
            </div>
            <div class="col-sm-3">
              <span>{{ getDistributorCommissionAmount(item) | toCurrencyUSD }}</span>
            </div>
            <div class="col-sm-3">
              <span>{{
                (getDistributorCommissionAmount(item) * validDollarQuotation(dollarQuotation)) | toCurrencyARS
              }}</span>
            </div>

            <div v-if="isAdmin || isSeller" class="col-sm-2 text-right pr-4">
              <small>Zonal</small>
            </div>
            <div class="col-sm-3">
              <small>{{ order.producer.distributor.seller.commission }} %</small>
            </div>
            <div class="col-sm-3">
              <span>{{ getSellerCommissionAmount(item) | toCurrencyUSD }}</span>
            </div>
            <div class="col-sm-3">
              <span>{{
                (getSellerCommissionAmount(item) * validDollarQuotation(dollarQuotation)) | toCurrencyARS
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <hr />
    </div>
  </div>
</template>

<script>
import { isSeller, isDistributor, isAdmin } from '@/util/roles';

export default {
  name: 'CommissionByItems',
  props: {
    order: {
      type: Object,
      required: true,
    },

    dollarQuotation: {
      type: Number,
      required: true,
    },
  },

  computed: {
    isAdmin() {
      return isAdmin(this.$auth.user());
    },

    isDistributor() {
      return isDistributor(this.$auth.user());
    },

    isSeller() {
      return isSeller(this.$auth.user());
    },
  },

  methods: {
    getDistributorCommission(item) {
      return (item.price - item.distributorCost) / item.price;
    },

    getSellerCommission(item) {
      return ((item.distributorCost / item.price) * Number(this.order.producer.distributor.seller.commission)) / 100;
    },

    getDistributorCommissionAmount(item) {
      return this.getDistributorCommission(item) * item.quantity * item.price;
    },

    getSellerCommissionAmount(item) {
      return this.getSellerCommission(item) * item.quantity * item.price;
    },

    validDollarQuotation(item) {
      return isNaN(item) ? 0 : item;
    },
  },
};
</script>
